import { CursorArrowRaysIcon } from '@heroicons/react/24/solid'

import { CROSS_JOBS, CROSS_TALENTS } from '../content'
import { anim, clamp, lerp, travel } from '../motion'
import { Avatar, Box } from '../primitives'

// Schritte: 0 Kreuzmatching starten · 1 Matrix füllt sich · 2 Bester Match
const GRID = { x: 200, y: 64, col: 160, row: 72 }
const LENA = CROSS_TALENTS.findIndex((t) => t.highlight)
const BEST = CROSS_TALENTS[LENA].values.indexOf(
  Math.max(...CROSS_TALENTS[LENA].values)
)

// Heatmap von Hellblau (50 %) nach Aivy Blue (95 %), flach ohne Transparenz
const PALE = [235, 239, 253]
const BLUE = [64, 123, 255]
const heat = (v) => {
  const t = clamp((v - 50) / 45)
  return `rgb(${PALE.map((c, i) => Math.round(lerp(c, BLUE[i], t))).join(',')})`
}

export default function SceneCrossMatch() {
  return (
    <>
      <Box
        x={40}
        y={40}
        w={420}
        h={120}
        className='sty-card sty-pad sty-row'
        style={anim({ at: [0.01, 0.1], x: -30, y: 0 })}
      >
        <Avatar initials='L' color='pink' size={52} />
        <div className='sty-grow'>
          <div className='sty-h4'>Lena K.</div>
          <div className='sty-muted'>eingeladen für Vertrieb</div>
        </div>
        <div className='sty-swap'>
          <span
            className='sty-badge sty-badge--yellow'
            style={anim({ at: [-1, 0], out: [0.74, 0.78], y: 0, oy: -12 })}
          >
            64&nbsp;% Vertrieb
          </span>
          <span
            className='sty-badge sty-badge--green'
            style={anim({ at: [0.77, 0.82], y: 12 })}
          >
            91&nbsp;% Customer Success
          </span>
        </div>
      </Box>

      <Box
        x={500}
        y={72}
        w={250}
        h={56}
        className='sty-btn sty-btn--lg'
        style={anim({ at: [0.03, 0.1], x: 30, y: 0 })}
      >
        Kreuzmatching starten
      </Box>
      <div
        className='sty-abs'
        style={{
          left: 0,
          top: 0,
          ...anim({ at: [0.08, 0.11], out: [0.3, 0.34], y: 0, oy: 0 })
        }}
      >
        <div
          style={travel({
            at: [0.09, 0.17],
            from: [900, 300],
            to: [700, 104],
            keep: true
          })}
        >
          <CursorArrowRaysIcon width={34} height={34} color='#182033' />
        </div>
      </div>

      <Box
        x={40}
        y={190}
        w={880}
        h={410}
        className='sty-card'
        style={anim({ at: [0.33, 0.4], y: 30 })}
      >
        {CROSS_JOBS.map((job, c) => (
          <div
            key={job}
            className='sty-abs sty-col-head'
            style={{
              left: GRID.x + c * GRID.col,
              top: 24,
              width: GRID.col - 12
            }}
          >
            {job}
          </div>
        ))}

        <div
          className='sty-abs sty-row-highlight'
          style={{
            left: 12,
            top: GRID.y + LENA * GRID.row - 6,
            width: 856,
            height: GRID.row,
            ...anim({ at: [0.67, 0.74], s: 0.96, y: 0 })
          }}
        />

        {CROSS_TALENTS.map((talent, r) => (
          <div key={talent.name}>
            <div
              className='sty-abs sty-row'
              style={{ left: 28, top: GRID.y + r * GRID.row + 10 }}
            >
              <Avatar
                initials={talent.name[0]}
                color={talent.highlight ? 'pink' : '#B2B4B6'}
                size={32}
              />
              <span className='sty-strong'>{talent.name}</span>
            </div>
            {talent.values.map((v, c) => (
              <div
                key={c}
                className='sty-abs'
                style={{
                  left: GRID.x + c * GRID.col,
                  top: GRID.y + r * GRID.row,
                  width: GRID.col - 12,
                  height: GRID.row - 12
                }}
              >
                <div
                  className='sty-cell'
                  style={{
                    background: heat(v),
                    color: v >= 76 ? '#fff' : '#182033',
                    ...anim({
                      at: [
                        0.36 + (r * 4 + c) * 0.008,
                        0.41 + (r * 4 + c) * 0.008
                      ],
                      s: 0.6,
                      y: 0
                    })
                  }}
                >
                  {v}&nbsp;%
                </div>
                {r === LENA && c === BEST && (
                  <>
                    <div
                      className='sty-cell-best'
                      style={anim({ at: [0.72, 0.8], s: 1.3, y: 0 })}
                    />
                    <span
                      className='sty-cell-tag'
                      style={anim({ at: [0.75, 0.82], y: 10 })}
                    >
                      Bester Match
                    </span>
                  </>
                )}
              </div>
            ))}
          </div>
        ))}
      </Box>
    </>
  )
}
